import React from 'react'

export default function Modal({ id, isFullscreen, payload, removeModal }) {
  const ref = React.useRef()

  const handleClose = () => {
    ref.current.close()
    removeModal(id)
  }

  React.useEffect(() => {
    if (!ref.current.open) {
      ref.current.showModal()
    }
  }, [])

  return (
    <dialog
      className={`fixed rounded shadow-xl ${isFullscreen ? 'w-full' : ''}`}
      onClose={() => removeModal(id)}
      ref={ref}
    >
      <button
        className="ml-auto block transition-opacity hover:opacity-70"
        onClick={handleClose}
        type="button"
      >
        <span
          aria-label="acknowledge"
          role="img"
          style={{
            filter: 'grayscale(1) brightness(0)'
          }}
        >
          ❌
        </span>
      </button>

      <div className="mt-4">{payload}</div>
    </dialog>
  )
}
